<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="姓名">
          <el-input v-model="searchData.idName" size="small" placeholder="请输入姓名"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input v-model="searchData.mobile" size="small" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="身份证号">
          <el-input v-model="searchData.idCard" size="small" placeholder="请输入身份证号"></el-input>
        </el-form-item>

        <el-form-item label=" " label-width="50px">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getList">搜索</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-divider></el-divider>

    <el-button
      v-checkbtn="isShowBtn(AUTH_BTN.black_list_add)"
      style="margin-bottom:20px"
      type="primary"
      icon="el-icon-plus"
      size="small"
      @click="$router.push({ name: 'BlackAdd' })"
    >
      新增
    </el-button>
    <el-button
      v-checkbtn="isShowBtn(AUTH_BTN.black_list_import)"
      style="margin-bottom:20px"
      type="info"
      icon="el-icon-upload2"
      size="small"
      @click="handleUpload"
    >
      批量导入
    </el-button>

    <tp-table
      :is-need-serial-number="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 导入 -->
    <ImportFile ref="importFile" @getList="getList" />
    <div style="height:50px"></div>
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';
import { getListAPI, removeRosterAPI } from './api';
import ImportFile from './import-file.vue';

const columns = [
  {
    label: '用户姓名',
    prop: 'idName',
    minWidth: '120',
    customRender(h, row) {
      return <p>{ row['idName'] }</p>
    }
  },
  {
    label: '身份证号',
    prop: 'idCardMask',
    minWidth: '180',
    customRender(h, row) {
      return <p>{ row['idCardMask'] }</p>
    }
  },
  {
    label: '手机号',
    prop: 'mobileMask',
    minWidth: '120',
    customRender(h, row) {
      return <p>{ row['mobileMask'] }</p>
    }
  },
  {
    label: '创建时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{ row['createTime'] }</p>
    }
  },
  {
    label: '平台',
    prop: 'appName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{ row['appName'] || "风控中台" }</p>
    }
  },
  {
    label: '备注',
    prop: 'remark',
    minWidth: '200',
    customRender(h, row) {
      return <p>{ row['remark'] }</p>
    }
  },
  {
    label: '操作',
    width: '180',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div>
          <el-link
            v-show={ !row['appName'] }
            disabled={ !this.isShowBtn(this.AUTH_BTN.black_list_remove) }
            underline={ false }
            type="primary"
            onClick={() => this.handleRemove(row['id'])}
          >
            移除
          </el-link>
        </div>
      )
    }
  }
]

export default {
  name: 'BlackList',
  mixins: [authBtnMixin],
  components: { ImportFile },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        idCard: '',
        mobile: '',
        idName: '',
      },
    }
  },

  provide() {
    return {
      context: this
    }
  },

  watch: {
    currentPage() {
      this.getList();
    },

    pageSize() {
      this.getList();
    },
  },

  activated() {
    this.getList();
  },

  methods: {
    async getList() {
      let params = { page: this.currentPage, riskLevel: 2, pageSize: this.pageSize };
      Object.assign(params, this.searchData);
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },

    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },

    handleUpload() {
      this.$refs.importFile.dialogImport = true;
      this.$nextTick(() => {
        this.$refs.importFile.clear();
      });
    },

    async handleRemove(id) {
      console.log('@@handleRemove', id);
      this.$confirm('此操作将永久删除该黑名单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            removeRosterAPI({ id }).then(() => {
              this.$message.success('删除成功');
              this.getList();
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 250px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .move-content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    .item {
      flex: 1;
      margin: 0 50px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 15px;
      padding-right: 20px;
      display: flex;
      justify-content: space-between;
      & > span {
        font-size: 16px;
        &:first-child {
          margin-right: 100px;
        }
      }
      .el-checkbox__inner {
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        &::after {
          left: 6px;
          height: 11px;
          width: 5px;
        }
      }
    }
  }
  .move-submit {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 20px;
  }
}
</style>
